import { Check } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";

const STEP_KEYS = ["service", "date", "time", "info", "confirm"];

export const BookingStepper = ({ currentStep }) => {
  const { t } = useLanguage();

  return (
    <div data-testid="booking-stepper" className="flex items-center justify-between max-w-xl mx-auto mb-10">
      {STEP_KEYS.map((key, idx) => {
        const stepNum = idx + 1;
        const done = stepNum < currentStep;
        const active = stepNum === currentStep;
        return (
          <div key={key} className="flex items-center flex-1">
            <div className="flex flex-col items-center gap-2">
              <div
                data-testid={`stepper-item-${key}`}
                className={`w-8 h-8 rounded-full flex items-center justify-center text-xs border transition-colors ${
                  active ? "bg-gold text-white border-gold" : done ? "bg-gold/20 text-gold border-gold/40" : "bg-transparent text-white/40 border-white/20"
                }`}
              >
                {done ? <Check size={14} /> : stepNum}
              </div>
              <span className={`text-[10px] uppercase tracking-widest hidden sm:block ${active ? "text-gold" : "text-white/40"}`}>
                {t(`booking.steps.${key}`)}
              </span>
            </div>
            {idx < STEP_KEYS.length - 1 && <div className={`flex-1 h-px mx-1 sm:mx-2 ${done ? "bg-gold/40" : "bg-white/10"}`} />}
          </div>
        );
      })}
    </div>
  );
};
